import React, { ChangeEvent } from 'react';
import Input from '../input/Input';

interface PercentInputProps {
  value: number;
  setValue: (newValue: number) => void;
  setValid?: (valid: boolean) => void;
  disabled?: boolean;
  viewMode?: boolean;
}

export const PercentInput: React.FC<PercentInputProps> = ({
  value,
  setValue,
  setValid,
  disabled = false,
  viewMode = false,
}) => {
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextValue = parseFloat(e.target.value);

    if (nextValue > 100 || nextValue <= 0) {
      setValid?.(false);
    } else {
      if (Number.isNaN(nextValue)) {
        setValid?.(false);
      } else {
        setValid?.(true);
      }
      setValue(parseFloat(nextValue.toFixed(2)));
    }
  };

  return (
    <div
      className="percent-input"
      onMouseDown={(e) => {
        e.stopPropagation();
      }}>
      <Input
        wrapperDivClassName={`percent-input__input-wrapper ${disabled ? 'disabled' : ''}`}
        className="percent-input__input"
        fullWidth={false}
        type="number"
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
      />
      <div className={`pdq-arrows-wrapper ${disabled ? 'disabled' : ''}`}>
        <div
          className={`up ${!viewMode && 'clickable'}`}
          onClick={(e) => {
            if (disabled) return;

            e.stopPropagation();
            if (value > 99) {
              setValue(100);
              return;
            }

            if (Number.isNaN(value)) {
              setValue(1);
              return;
            }

            const nextValue = value + 1;
            setValue(nextValue);
          }}>
          <img src="./assets/icons/arrow.svg" />
        </div>
        <div
          className={`down ${!viewMode && 'clickable'}`}
          onClick={(e) => {
            if (disabled) return;

            e.stopPropagation();
            if (value < 1 || Number.isNaN(value)) {
              setValue(0);
              return;
            }

            const nextValue = value - 1;
            setValue(nextValue);
          }}>
          <img src="./assets/icons/arrow.svg" />
        </div>
      </div>
    </div>
  );
};
